import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useAppData } from '../data'
import { ExplorerPageContent } from '../components/explorer/ExplorerPageContent'

export function ExplorarPage() {
  const appData = useAppData()
  const { search } = useLocation()

  // Trigger the bills index fetch whenever the query string changes (mirrors
  // the Rust ExplorarPage Effect that calls trigger_bills_index on each
  // query_map change — ensuring the index loads when the page is visited with
  // any query params, not just on initial load).
  // Note: this page-level trigger covers initial load and param-driven navigation;
  // the onFocus trigger in ExplorerPageContent covers the lazy interactive path.
  useEffect(() => {
    appData.triggerBillsIndex()
  // appData is stable; search is the only dep that drives re-triggering.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  return <ExplorerPageContent />
}
